function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { of } from 'rxjs';
import { concatMap, filter, map } from 'rxjs/operators';
import { HttpHeaders } from "./headers";
import { HttpParams } from "./params";
import { HttpRequest } from "./request";
import { HttpResponse } from "./response";

//观察 body ， evens, response;

function addBody(options, body) {
  return {
    body: body,
    headers: options.headers,
    observe: options.observe,
    params: options.params,
    withCredentials: options.withCredentials
  };
}
export var HttpClient = /*#__PURE__*/function () {
  function HttpClient(handler) {
    _classCallCheck(this, HttpClient);
    _defineProperty(this, "handler", void 0);
    this.handler = handler;
  }
  _createClass(HttpClient, [{
    key: "request",
    value: function request(first, url) {
      var _this = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var req;
      if (first instanceof HttpRequest) {
        req = first;
      } else {
        var method = first;
        // Figure out the headers.
        var headers = undefined;
        if (options.headers instanceof HttpHeaders) {
          headers = options.headers;
        } else {
          headers = new HttpHeaders(options.headers);
        }

        // Sort out parameters.
        var params = undefined;
        if (!!options.params) {
          if (options.params instanceof HttpParams) {
            params = options.params;
          } else {
            params = new HttpParams({
              fromObject: options.params
            });
          }
        }
        req = new HttpRequest(method, url, options.body !== undefined ? options.body : null, {
          params: params,
          headers: headers,
          // By default, JSON is assumed to be returned for all calls.
          responseType: options.responseType || 'json',
          withCredentials: options.withCredentials
        });
      }
      var events = of(req).pipe(concatMap(function (req) {
        return _this.handler.handle(req);
      }));
      if (first instanceof HttpRequest || options.observe === 'events') {
        return events;
      }
      var res$ = events.pipe(filter(function (event) {
        return event instanceof HttpResponse;
      }));
      switch (options.observe || 'body') {
        case 'body':
          switch (req.responseType) {
            case 'json':
            default:
              return res$.pipe(map(function (res) {
                return res.body;
              }));
          }
        case 'response':
          return res$;
        default:
          throw new Error("Unreachable unhandled observe type ".concat(options.observe));
      }
    }
  }, {
    key: "get",
    value: function get(url, options) {
      return this.request('GET', url, options);
    }
  }, {
    key: "post",
    value: function post(url, body, options) {
      return this.request('POST', url, addBody(options, body));
    }
  }, {
    key: "put",
    value: function put(url, body, options) {
      return this.request('PUT', url, addBody(options, body));
    }
  }, {
    key: "patch",
    value: function patch(url, body, options) {
      return this.request('PATCH', url, addBody(options, body));
    }
  }, {
    key: "delete",
    value: function _delete(url, options) {
      return this.request('DELETE', url, options);
    }
  }]);
  return HttpClient;
}();